module.exports = __webpack_public_path__ + "media/images/food-fcab98f97efafb5d8f6c3295c1c275d4.png";